import {
  defineMessages,
  LOCALE_KEY,
  type LocaleValue,
} from '@transcend-io/internationalization';

// Maybe pull these into the internationalization repo at some point? These will likely be reused

export const localeDescriptorMessages = defineMessages<LocaleValue>(
  'internationalization.src.localeDescriptor',
  {
    [LOCALE_KEY.En]: {
      defaultMessage: 'English',
    },
    [LOCALE_KEY.Ar]: {
      defaultMessage: 'Arabic',
    },
    [LOCALE_KEY.Fr]: {
      defaultMessage: 'French',
    },
    [LOCALE_KEY.Es]: {
      defaultMessage: 'Spanish',
    },
    [LOCALE_KEY.De]: {
      defaultMessage: 'German',
    },
    [LOCALE_KEY.It]: {
      defaultMessage: 'Italian',
    },
    [LOCALE_KEY.Ja]: {
      defaultMessage: 'Japanese',
    },
    [LOCALE_KEY.Ru]: {
      defaultMessage: 'Russian',
    },

    [LOCALE_KEY.ArAe]: {
      defaultMessage: 'Arabic UAE',
    },
    [LOCALE_KEY.FrFr]: {
      defaultMessage: 'French',
    },
    [LOCALE_KEY.DeDe]: {
      defaultMessage: 'German (Germany)',
    },
    [LOCALE_KEY.ItIt]: {
      defaultMessage: 'Italian',
    },
    [LOCALE_KEY.AfZz]: {
      defaultMessage: 'Afrikaans',
    },
    [LOCALE_KEY.BgBg]: {
      defaultMessage: 'Bulgarian',
    },
    [LOCALE_KEY.ZhCn]: {
      defaultMessage: 'Chinese (Simplified)',
    },
    [LOCALE_KEY.HrHr]: {
      defaultMessage: 'Croatian',
    },
    [LOCALE_KEY.CsCz]: {
      defaultMessage: 'Czech',
    },
    [LOCALE_KEY.DaDk]: {
      defaultMessage: 'Danish',
    },
    [LOCALE_KEY.EnGb]: {
      defaultMessage: 'English (United Kingdom)',
    },
    [LOCALE_KEY.EnCa]: {
      defaultMessage: 'English (Canada)',
    },
    [LOCALE_KEY.EnAe]: {
      defaultMessage: 'English (UAE)',
    },
    [LOCALE_KEY.FiFi]: {
      defaultMessage: 'Finnish',
    },
    [LOCALE_KEY.ElGr]: {
      defaultMessage: 'Greek',
    },
    [LOCALE_KEY.HiIn]: {
      defaultMessage: 'Hindi',
    },
    [LOCALE_KEY.HuHu]: {
      defaultMessage: 'Hungarian',
    },
    [LOCALE_KEY.IdId]: {
      defaultMessage: 'Indonesian',
    },
    [LOCALE_KEY.JaJp]: {
      defaultMessage: 'Japanese',
    },
    [LOCALE_KEY.KoKr]: {
      defaultMessage: 'Korean',
    },
    [LOCALE_KEY.LtLt]: {
      defaultMessage: 'Lithuanian',
    },
    [LOCALE_KEY.MsMy]: {
      defaultMessage: 'Malay',
    },
    [LOCALE_KEY.MrIn]: {
      defaultMessage: 'Marathi',
    },
    [LOCALE_KEY.NbNi]: {
      defaultMessage: 'Norwegian Bokmål',
    },
    [LOCALE_KEY.PlPl]: {
      defaultMessage: 'Polish',
    },
    [LOCALE_KEY.PtBr]: {
      defaultMessage: 'Portuguese (Brazil)',
    },
    [LOCALE_KEY.PtPt]: {
      defaultMessage: 'Portuguese (Portugal)',
    },
    [LOCALE_KEY.RoRo]: {
      defaultMessage: 'Romanian',
    },
    [LOCALE_KEY.RuRu]: {
      defaultMessage: 'Russian',
    },
    [LOCALE_KEY.SrLatnRs]: {
      defaultMessage: 'Latn-Serbian (Latin)',
    },
    [LOCALE_KEY.SvSe]: {
      defaultMessage: 'Swedish',
    },
    [LOCALE_KEY.TaIn]: {
      defaultMessage: 'Tamil',
    },
    [LOCALE_KEY.ThTh]: {
      defaultMessage: 'Thai',
    },
    [LOCALE_KEY.TrTr]: {
      defaultMessage: 'Turkish',
    },
    [LOCALE_KEY.UkUa]: {
      defaultMessage: 'Ukrainian',
    },
    [LOCALE_KEY.ViVn]: {
      defaultMessage: 'Vietnamese',
    },
    [LOCALE_KEY.ZuZa]: {
      defaultMessage: 'Zulu',
    },
    [LOCALE_KEY.EnUs]: {
      defaultMessage: 'English (United States)',
    },
    [LOCALE_KEY.EnAu]: {
      defaultMessage: 'Australia',
    },
    [LOCALE_KEY.FrBe]: {
      defaultMessage: 'Belgium',
    },
    [LOCALE_KEY.FrCa]: {
      defaultMessage: 'French (Canada)',
    },
    [LOCALE_KEY.EnIe]: {
      defaultMessage: 'Ireland',
    },
    [LOCALE_KEY.NlNl]: {
      defaultMessage: 'Dutch',
    },
    [LOCALE_KEY.NlBe]: {
      defaultMessage: 'Dutch (Belgium)',
    },
    [LOCALE_KEY.EsEs]: {
      defaultMessage: 'Spanish (Castilian)',
    },
    [LOCALE_KEY.Es419]: {
      defaultMessage: 'Spanish (Latin America & Caribbean)',
    },
    [LOCALE_KEY.ZhHk]: {
      defaultMessage: 'Chinese (Traditional)',
    },
    [LOCALE_KEY.DeAt]: {
      defaultMessage: 'Austrian German',
    },
    [LOCALE_KEY.DeCh]: {
      defaultMessage: 'Swiss German',
    },
    [LOCALE_KEY.ItCh]: {
      defaultMessage: 'Swiss Italian',
    },
    [LOCALE_KEY.FrCh]: {
      defaultMessage: 'French (Switzerland)',
    },
    [LOCALE_KEY.HeIl]: {
      defaultMessage: 'Hebrew (Israel)',
    },
    [LOCALE_KEY.EnNz]: {
      defaultMessage: 'English (New Zealand)',
    },
    [LOCALE_KEY.EtEe]: {
      defaultMessage: 'Estonian (Estonia)',
    },
    [LOCALE_KEY.IsIs]: {
      defaultMessage: 'Icelandic (Iceland)',
    },
    [LOCALE_KEY.LvLv]: {
      defaultMessage: 'Latvian (Latvia)',
    },
    [LOCALE_KEY.MtMt]: {
      defaultMessage: 'Maltese (Malta)',
    },
    [LOCALE_KEY.SkSk]: {
      defaultMessage: 'Slovak (Slovakia)',
    },
    [LOCALE_KEY.SlSl]: {
      defaultMessage: 'Slovenian (Slovenia)',
    },
  },
);
